<template>
  <gg-card>
    <gg-card-header>
      <div class="d-flex align-center flex-wrap">
        <span class="mr-auto">{{ title }}</span>
        <!-- e.g. a Create button, for pages that keep the form out of view. -->
        <slot name="header-actions" />
      </div>
    </gg-card-header>
    <gg-card-text>
      <v-data-table v-bind="tableProps">
        <template v-slot:item.actions="{ item }">
          <gg-btn color="primary" elevation="0" @click="triggerModel(item.dest, item.forward, item.type)">
            Delete
          </gg-btn>
        </template>
      </v-data-table>

      <template>
        <gg-modal :is-active="emailDialog" @close="triggerEmailModal">
          <template v-slot:toolbar>
            Delete Forwarder?
          </template>
          <template v-slot:body>
            Are you sure you want to delete the email forwarder “{{ model.dest }}” to “{{ model.forward }}”?
          </template>
          <template v-slot:actions>
            <gg-btn secondary @click="triggerEmailModal">
              Cancel
            </gg-btn>
            <gg-btn primary :loading="pending" @click="deleteEmailForwarder">
              Delete
            </gg-btn>
          </template>
        </gg-modal>
      </template>
      <template>
        <gg-modal :is-active="domainDialog" @close="triggerDomainModal">
          <template v-slot:toolbar>
            Delete Forwarder?
          </template>
          <template v-slot:body>
            Are you sure you want to delete the domain forwarder “{{ model.dest }}” to “{{ model.forward }}”?
          </template>
          <template v-slot:actions>
            <gg-btn secondary @click="triggerDomainModal">
              Cancel
            </gg-btn>
            <gg-btn primary :loading="pending" @click="deleteDomainForwarder">
              Delete
            </gg-btn>
          </template>
        </gg-modal>
<!--          <delete-domain-forwarder :is-active="domainDialog"-->
<!--                                   :dest="model.dest"-->
<!--                                   :forward="model.forward"-->
<!--                                   @close="triggerDomainModal"-->
<!--                                   @action-completed="$emit('update')"-->
<!--          />-->
        </template>
      </gg-card-text>
    </gg-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'EmailForwarders',
  props: {
    title: {
      type: String,
      default: 'Manage Forwarding Rules',
    },
  },
  data: () => ({
    model: {
      dest: '',
      forward: '',
    },
    headers: [
      {
        text: 'Email address',
        value: 'dest',
        sortable: false,
      },
      {
        text: 'Forward to',
        value: 'forward',
        sortable: false,
      },
      {
        text: 'Actions',
        value: 'actions',
        align: 'center',
        sortable: false,
      }
    ],
    emailDialog: false,
    domainDialog: false,
    pending: false
  }),
  computed: {
    ...mapGetters({
      forwarders: 'email/forwarders',
    }),
    items () {
      const items = []

      for (let key in this.forwarders) {
        if (key === 'domain') { continue }

        if (key === 'forwarders') {
          this.forwarders[key].forEach(f => {
            items.push({
              type: 'forwarders',
              ...f
            })
          })
        }
        if (key === 'domain_forwarders') {
          this.forwarders[key].forEach(f => {
            items.push({
              type: 'domain_forwarders',
              ...f
            })
          })
        }
      }

      return items
    },
    tableProps () {
      return {
        headers: this.headers,
        items: this.items,
        loading: this.$attrs.pending,
        'loader-height': 1
      }
    }
  },
  methods: {
    ...mapActions({
      setForwarders: 'email/setForwarders',
      removeForwarder: 'email/removeForwarder',
      removeDomainForwarder: 'email/removeDomainForwarder',
      reportSuccess: 'reportSuccess',
      reportError: 'reportError'
    }),
    triggerModel (dest = '', forward = '', type) {
      this.model.dest = dest !== '' ? dest : ''
      this.model.forward = forward !== '' ? forward : ''

      if (type === 'forwarders') {
        this.triggerEmailModal()
      } else {
        this.triggerDomainModal()
      }
    },
    triggerEmailModal () {
      this.emailDialog = !this.emailDialog
    },
    triggerDomainModal () {
      this.domainDialog = !this.domainDialog
    },
    async deleteEmailForwarder () {
      const data = {
        address: this.model.dest,
        forwarder: this.model.forward,
        _username: this.$route.query.user,
      }
      this.pending = true
      try {
        await this.removeForwarder(data)
        this.$emit('update')
        this.reportSuccess(`Forwarder succesfully deleted.`)
      } catch (e) {
        this.reportError(e)
      } finally {
        this.triggerEmailModal()
        this.pending = false
        // this.$emit('update')
      }
    },
    async deleteDomainForwarder () {
      const data = {
        domain: this.model.dest,
        _username: this.$route.query.user,
      }
      this.pending = true
      try {
        await this.removeDomainForwarder(data)
        this.$emit('update')
        this.reportSuccess(`Forwarder succesfully deleted.`)
      } catch (e) {
        this.reportError(e)
      } finally {
        this.triggerDomainModal()
        this.pending = false
      }
    },
  },
}
</script>
